module.exports = __webpack_public_path__ + "static/media/fm.41b339f3.svg";